import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@/lib/api-client";

export type AnomalySeverity = "error" | "warn";
export interface Anomaly {
  type: string;
  severity: AnomalySeverity;
  message: string;
  detail?: Record<string, unknown>;
}
export interface EntityAnomalies {
  grids: Record<string, Anomaly[]>;
  wind_sessions: Record<string, Anomaly[]>;
}

// Central anomaly feed. Polled every 15s — light SQL-only endpoint, safe to
// hit often. UI cards read this once and pluck their own entity's list.
export function useAnomalies() {
  return useQuery<EntityAnomalies>({
    queryKey: ["anomalies"],
    queryFn: () => apiGet<EntityAnomalies>("/anomalies"),
    refetchInterval: 15_000,
    // Show stale data while refetching instead of flicker.
    placeholderData: (prev) => prev,
  });
}

export function useGridAnomalies(gridId: string | undefined): Anomaly[] {
  const { data } = useAnomalies();
  if (!gridId || !data) return [];
  return data.grids[gridId] ?? [];
}

export function useWindSessionAnomalies(sessionId: string | undefined): Anomaly[] {
  const { data } = useAnomalies();
  if (!sessionId || !data) return [];
  return data.wind_sessions[sessionId] ?? [];
}
